import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6a4c22a3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "intro"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Close", -1));
const _hoisted_5 = {
    key: 1,
    class: "cbxList"
};
const _hoisted_6 = { class: "cbx-label" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "cbx-code" }, "Match all keywords", -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "cbx-label" }, [
    /*#__PURE__*/ _createTextVNode("Shows results which match "),
    /*#__PURE__*/ _createElementVNode("em", null, "every"),
    /*#__PURE__*/ _createTextVNode(" keyword ("),
    /*#__PURE__*/ _createElementVNode("em", null, "AND"),
    /*#__PURE__*/ _createTextVNode(" search)")
], -1));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "cbx-code" }, "With serial number", -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "cbx-label" }, "Show only parts with serial number", -1));
const _hoisted_11 = { class: "mobileProgress" };
const _hoisted_12 = {
    key: 0,
    class: "progressText"
};
const _hoisted_13 = {
    key: 1,
    class: "progressText"
};
const _hoisted_14 = { class: "progressText" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Filter", -1));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Selected items", -1));
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Send request", -1));
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Close", -1));
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Send request", -1));
import { SP, getUrlParameters, updateUrlParameter, getDefaultUrlParams, getConditionColor } from './sp';
import { computed, onUnmounted, reactive, ref, watch } from 'vue';
import { VInfiniteScroll } from 'vuetify/components/VInfiniteScroll';
import ShortPartsList from './ShortPartsList.vue';
import RequestForm from './RequestForm.vue';
import SparePartCard from './SparePartCard.vue';
import { VBottomSheet } from 'vuetify/components/VBottomSheet';
var ScreenSize;
(function (ScreenSize) {
    ScreenSize[ScreenSize["Small"] = 0] = "Small";
    ScreenSize[ScreenSize["Medium"] = 1] = "Medium";
    ScreenSize[ScreenSize["Large"] = 2] = "Large";
})(ScreenSize || (ScreenSize = {}));
export default /*#__PURE__*/ _defineComponent({
    __name: 'SPSearchApp',
    props: {
        config: {}
    },
    setup(__props) {
        const props = __props;
        const searchArgs = reactive(getDefaultUrlParams());
        const initialFilters = getUrlParameters();
        for (const arg of Object.keys(initialFilters)) {
            searchArgs[arg] = initialFilters[arg];
        }
        const onPopstate = event => {
            var _a, _b;
            const args = (_a = event.state) === null || _a === void 0 ? void 0 : _a.searchArgs;
            if (args) {
                const defaults = getDefaultUrlParams();
                for (const arg of Object.keys(defaults)) {
                    searchArgs[arg] = (_b = args[arg]) !== null && _b !== void 0 ? _b : defaults[arg];
                }
            }
        };
        window.addEventListener('popstate', onPopstate);
        const sparts = reactive({
            results: [],
            totalFound: 0,
            offset: 0,
        });
        const spartPairs = computed(() => sparts.results.reduce((acc, spart) => {
            if (acc[acc.length - 1]) {
                if (acc[acc.length - 1].length === 2) {
                    acc.push([spart]);
                }
                else {
                    acc[acc.length - 1].push(spart);
                }
            }
            else {
                acc.push([spart]);
            }
            return acc;
        }, []));
        const quote = reactive({
            sparts: [],
            openDialog: false,
        });
        const scrollerEl = ref();
        const resultsOuterRef = ref();
        const paginationProgress = computed(() => !sparts.totalFound ? 0 : Math.round(sparts.results.length / sparts.totalFound * 100));
        const mobilePartsListVisible = ref(false);
        const mobileFilterVisible = ref(false);
        const controlsWrapper = computed(() => {
            return screenSize.value === ScreenSize.Small ? VBottomSheet : 'div';
        });
        const searchState = reactive({
            isSearching: false,
            searchAgain: false,
            virtualScrollerCbs: [],
            searchArgsHash: '',
        });
        const windowWidth = ref(window.innerWidth);
        const screenSize = computed(() => {
            if (windowWidth.value <= 600) {
                return ScreenSize.Small;
            }
            else if (windowWidth.value <= 1200) {
                return ScreenSize.Medium;
            }
            else {
                return ScreenSize.Large;
            }
        });
        window.addEventListener('resize', updateScreenWidth);
        window.addEventListener('orientationchange', updateScreenWidth);
        function updateScreenWidth() {
            windowWidth.value = window.innerWidth;
        }
        let queryTimeout = null;
        function clearQueryTimeout() {
            if (queryTimeout) {
                window.clearTimeout(queryTimeout);
                queryTimeout = null;
            }
        }
        watch(() => searchArgs.query, async (next, prev) => {
            clearQueryTimeout();
            if (next !== prev) {
                queryTimeout = window.setTimeout(() => {
                    clearQueryTimeout();
                    loadMore({ reload: true }).then(() => updateUrlParameter(SP.FilterKeys.query, searchArgs.query || null));
                }, 250);
            }
        });
        watch(() => [
            searchArgs.conditionCodes,
            searchArgs.withSerialNumber,
            searchArgs.matchAllKeywords,
            searchArgs.orderBy,
            searchArgs.order,
        ], async () => {
            clearQueryTimeout();
            loadMore({ reload: true });
        });
        watch(() => searchArgs.conditionCodes, (next) => updateUrlParameter(SP.FilterKeys.conditionCodes, next.length ? next : null));
        watch(() => searchArgs.withSerialNumber, (next) => updateUrlParameter(SP.FilterKeys.withSerialNumber, next || null));
        watch(() => searchArgs.matchAllKeywords, (next) => updateUrlParameter(SP.FilterKeys.matchAllKeywords, next || null));
        watch(() => searchArgs.orderBy, (next) => updateUrlParameter(SP.FilterKeys.orderBy, next === 'relevance' ? null : next));
        watch(() => searchArgs.order, (next) => updateUrlParameter(SP.FilterKeys.order, next === 'DESC' ? null : next));
        onUnmounted(() => {
            clearQueryTimeout();
            window.removeEventListener('popstate', onPopstate);
            window.removeEventListener('resize', updateScreenWidth);
            window.removeEventListener('orientationchange', updateScreenWidth);
        });
        function scrollToTop() {
            var _a;
            const scrollOffsetTop = (_a = resultsOuterRef.value) === null || _a === void 0 ? void 0 : _a.offsetTop;
            if (scrollOffsetTop) {
                window.scrollTo({ top: scrollOffsetTop, behavior: 'smooth' });
                if (document.documentElement.style.getPropertyValue('--v-body-scroll-y')) {
                    // This updates vuetify's overlay "frozen" scroll offse
                    document.documentElement.style.setProperty('--v-body-scroll-y', `-${scrollOffsetTop}px`);
                }
            }
        }
        async function loadMore(args) {
            if (args.done) {
                searchState.virtualScrollerCbs.push(args.done);
            }
            const searchArgsHash = JSON.stringify(searchArgs);
            if (searchState.isSearching) {
                if (searchState.searchArgsHash !== searchArgsHash) {
                    searchState.searchAgain = args.reload ? 'reload' : 'load';
                }
                return;
            }
            searchState.searchArgsHash = searchArgsHash;
            searchState.isSearching = true;
            if (args.reload && screenSize.value === ScreenSize.Small) {
                scrollToTop();
            }
            const complete = async (status) => {
                searchState.isSearching = false;
                if (searchState.searchAgain) {
                    const rel = searchState.searchAgain === 'reload';
                    searchState.searchAgain = false;
                    await loadMore({ reload: rel });
                }
                else {
                    searchState.virtualScrollerCbs.forEach((cb) => cb(status));
                    searchState.virtualScrollerCbs = [];
                }
            };
            if (args.reload) {
                sparts.results = [];
                sparts.offset = 0;
            }
            else {
                sparts.offset = sparts.results.length;
            }
            try {
                const url = new URL(props.config.rest.endpoints.search);
                url.searchParams.append('session_token', props.config.session_token);
                url.searchParams.append('query', searchArgs.query);
                if (searchArgs.conditionCodes.length) {
                    url.searchParams.append('condition_codes', searchArgs.conditionCodes.join(','));
                }
                url.searchParams.append('order_by', searchArgs.orderBy);
                url.searchParams.append('order', searchArgs.order);
                if (sparts.offset) {
                    url.searchParams.append('offset', sparts.offset.toString());
                }
                url.searchParams.append('limit', (props.config.default_limit_per_page || 10).toString());
                if (searchArgs.withSerialNumber) {
                    url.searchParams.append('serial_number', 'true');
                }
                if (searchArgs.matchAllKeywords) {
                    url.searchParams.append('multiterm_logic', 'AND');
                }
                const resp = await (await fetch(url, {
                    method: 'GET',
                    headers: {
                        'X-WP-Nonce': props.config.rest.nonce,
                        'Accept': 'application/json',
                    },
                })).json();
                if (!resp.success) {
                    throw new Error(resp.error);
                }
                sparts.results = sparts.results.concat(resp.data.results);
                sparts.totalFound = resp.data.total;
                if (!sparts.results.length || sparts.results.length >= sparts.totalFound) {
                    return complete('empty');
                }
                else {
                    return complete('ok');
                }
            }
            catch (err) {
                return complete('error');
            }
        }
        function toggleSparePartQuote(spart) {
            if (isSparePartInQuote(spart)) {
                quote.sparts = quote.sparts.filter((q) => q.id !== spart.id);
            }
            else {
                quote.sparts.push(spart);
            }
        }
        function refresh() {
            mobileFilterVisible.value = false;
            mobilePartsListVisible.value = false;
            quote.sparts = [];
        }
        function isSparePartInQuote(spart) {
            return quote.sparts.some((q) => q.id === spart.id);
        }
        function toggleConditionCode(cond, desiredState) {
            searchArgs.conditionCodes = searchArgs.conditionCodes.includes(cond.code) || !desiredState
                ? searchArgs.conditionCodes.filter((c) => c !== cond.code)
                : searchArgs.conditionCodes.concat(cond.code);
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_progress_linear = _resolveComponent("v-progress-linear");
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_bottom_navigation = _resolveComponent("v-bottom-navigation");
            const _component_v_layout = _resolveComponent("v-layout");
            const _directive_ripple = _resolveDirective("ripple");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_v_layout, { class: "hsearch" }, {
                    default: _withCtx(() => [
                        (_ctx.config.block_args.title || _ctx.config.block_args.description)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                (_ctx.config.block_args.title)
                                    ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.config.block_args.title), 1))
                                    : _createCommentVNode("", true),
                                (_ctx.config.block_args.description)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        innerHTML: _ctx.config.block_args.description
                                    }, null, 8, _hoisted_3))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        (_openBlock(), _createBlock(_resolveDynamicComponent(controlsWrapper.value), {
                            modelValue: mobileFilterVisible.value,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((mobileFilterVisible).value = $event))
                        }, {
                            default: _withCtx(() => [
                                (controlsWrapper.value !== 'div')
                                    ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                        key: 0,
                                        variant: "flat",
                                        rounded: 0,
                                        onClick: _cache[0] || (_cache[0] = ($event) => (mobileFilterVisible.value = false))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_icon, null, {
                                                default: _withCtx(() => [
                                                    _createTextVNode("mdi-close")
                                                ]),
                                                _: 1
                                            }),
                                            _hoisted_4
                                        ]),
                                        _: 1
                                    })), [
                                        [_directive_ripple, false]
                                    ])
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_row, { class: "controls" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "6",
                                            md: "7",
                                            lg: "8"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                    modelValue: searchArgs.query,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((searchArgs.query) = $event)),
                                                    label: "Keywords, part number, etc.",
                                                    "prepend-inner-icon": "mdi-magnify",
                                                    variant: "outlined",
                                                    density: "comfortable"
                                                }, null, 8, ["modelValue"]),
                                                (windowWidth.value <= 1200)
                                                    ? (_openBlock(), _createBlock(_component_v_select, {
                                                        key: 0,
                                                        modelValue: searchArgs.conditionCodes,
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((searchArgs.conditionCodes) = $event)),
                                                        label: 'Condition' + (searchArgs.conditionCodes.length ? '' : ' (All)'),
                                                        items: props.config.conditions,
                                                        "item-title": "code",
                                                        "item-value": "code",
                                                        "item-subtitle": "label",
                                                        variant: "outlined",
                                                        density: "comfortable",
                                                        chips: "",
                                                        multiple: ""
                                                    }, {
                                                        item: _withCtx(({ props, item, modelValue }) => [
                                                            _createVNode(_component_v_divider, { class: "mb-2" }),
                                                            _createVNode(_component_v_list_item, _mergeProps(props, {
                                                                title: item.raw.code,
                                                                subtitle: item.raw.label,
                                                                role: "option"
                                                            }), {
                                                                prepend: _withCtx(() => [
                                                                    _createVNode(_component_v_checkbox_btn, {
                                                                        "model-value": searchArgs.conditionCodes.includes(item.raw.code),
                                                                        ripple: false,
                                                                        tabindex: "-1",
                                                                        color: "primary"
                                                                    }, null, 8, ["model-value"])
                                                                ]),
                                                                _: 2
                                                            }, 1040, ["title", "subtitle"])
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue", "label", "items"]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.config.conditions, (cond) => {
                                                            return (_openBlock(), _createBlock(_component_v_checkbox, {
                                                                class: "cbx",
                                                                color: _unref(getConditionColor)(cond.code),
                                                                key: cond.code,
                                                                "model-value": searchArgs.conditionCodes.includes(cond.code),
                                                                "onUpdate:modelValue": ($event) => (toggleConditionCode(cond, $event))
                                                            }, {
                                                                label: _withCtx(() => [
                                                                    _createElementVNode("span", _hoisted_6, _toDisplayString(cond.label), 1),
                                                                    _createVNode(_component_v_chip, {
                                                                        color: _unref(getConditionColor)(cond.code),
                                                                        variant: "tonal",
                                                                        size: "small"
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createElementVNode("b", null, _toDisplayString(cond.code), 1)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1032, ["color"])
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["color", "model-value", "onUpdate:modelValue"]));
                                                        }), 128))
                                                    ]))
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                            cols: "12",
                                            sm: "6",
                                            md: "5",
                                            lg: "4"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_row, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_col, { cols: "6" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_select, {
                                                                    modelValue: searchArgs.orderBy,
                                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((searchArgs.orderBy) = $event)),
                                                                    label: "Order by",
                                                                    items: [{ title: 'Relevance', value: 'relevance' }, { title: 'Quantity', value: 'total_quantity' }],
                                                                    variant: "outlined",
                                                                    density: "comfortable"
                                                                }, null, 8, ["modelValue"]),
                                                                _createVNode(_component_v_checkbox, _mergeProps(props, {
                                                                    modelValue: searchArgs.matchAllKeywords,
                                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((searchArgs.matchAllKeywords) = $event)),
                                                                    class: "cbx",
                                                                    variant: "outlined",
                                                                    density: "comfortable",
                                                                    color: "duskBlue"
                                                                }), {
                                                                    label: _withCtx(() => [
                                                                        _hoisted_7,
                                                                        _hoisted_8
                                                                    ]),
                                                                    _: 1
                                                                }, 16, ["modelValue"])
                                                            ]),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_v_col, { cols: "6" }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_select, {
                                                                    modelValue: searchArgs.order,
                                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((searchArgs.order) = $event)),
                                                                    label: "Order",
                                                                    "prepend-icon": searchArgs.order === 'ASC' ? 'mdi-sort-ascending' : 'mdi-sort-descending',
                                                                    items: [
                                                                        { title: 'Descending', value: 'DESC' },
                                                                        { title: 'Ascending', value: 'ASC' }
                                                                    ],
                                                                    variant: "outlined",
                                                                    density: "comfortable"
                                                                }, null, 8, ["modelValue", "prepend-icon"]),
                                                                _createVNode(_component_v_checkbox, _mergeProps(props, {
                                                                    modelValue: searchArgs.withSerialNumber,
                                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((searchArgs.withSerialNumber) = $event)),
                                                                    class: "cbx",
                                                                    variant: "outlined",
                                                                    density: "comfortable",
                                                                    color: "duskBlue"
                                                                }), {
                                                                    label: _withCtx(() => [
                                                                        _hoisted_9,
                                                                        _hoisted_10
                                                                    ]),
                                                                    _: 1
                                                                }, 16, ["modelValue"])
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                }),
                                                (screenSize.value === ScreenSize.Small)
                                                    ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_col, null, {
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("div", _hoisted_11, [
                                                                        _createVNode(_component_v_progress_linear, {
                                                                            "model-value": paginationProgress.value,
                                                                            color: "duskBlue",
                                                                            "bg-color": "jetBlack",
                                                                            "bg-opacity": "0.2",
                                                                            height: "3"
                                                                        }, null, 8, ["model-value"]),
                                                                        (sparts.results.length)
                                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                                                                _createTextVNode("Showing "),
                                                                                _createElementVNode("strong", null, _toDisplayString(sparts.results.length), 1),
                                                                                _createTextVNode(" of "),
                                                                                _createElementVNode("strong", null, _toDisplayString(sparts.totalFound), 1),
                                                                                _createTextVNode(" results")
                                                                            ]))
                                                                            : (_openBlock(), _createElementBlock("p", _hoisted_13, "Nothing found"))
                                                                    ])
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["modelValue"])),
                        _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "8"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", {
                                            class: "results-outer",
                                            ref_key: "resultsOuterRef",
                                            ref: resultsOuterRef
                                        }, [
                                            _createVNode(_unref(VInfiniteScroll), {
                                                items: sparts.results,
                                                onLoad: loadMore,
                                                ref_key: "scrollerEl",
                                                ref: scrollerEl,
                                                direction: "vertical"
                                            }, {
                                                empty: _withCtx(() => [
                                                    _createVNode(_component_v_container, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_row, null, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_v_chip, {
                                                                                color: "duskBlue",
                                                                                "prepend-icon": "mdi-information"
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(" No " + _toDisplayString(sparts.results.length ? 'more ' : '') + "results found ", 1)
                                                                                ]),
                                                                                _: 1
                                                                            })
                                                                        ]),
                                                                        _: 1
                                                                    })
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(spartPairs.value, (spartBundle) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            key: 'bundle' + spartBundle[0].id,
                                                            class: "cardsList-bundle"
                                                        }, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(spartBundle, (sparePart) => {
                                                                return (_openBlock(), _createBlock(SparePartCard, {
                                                                    key: sparePart.id,
                                                                    "spare-part": sparePart,
                                                                    config: _ctx.config,
                                                                    checkInQuote: isSparePartInQuote,
                                                                    onToggleSparePart: toggleSparePartQuote
                                                                }, null, 8, ["spare-part", "config"]));
                                                            }), 128))
                                                        ]));
                                                    }), 128))
                                                ]),
                                                _: 1
                                            }, 8, ["items"])
                                        ], 512),
                                        _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_col)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                                (sparts.results.length)
                                                    ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_progress_linear, {
                                                                "model-value": paginationProgress.value,
                                                                color: "duskBlue",
                                                                "bg-color": "jetBlack",
                                                                "bg-opacity": "0.2",
                                                                height: "3"
                                                            }, null, 8, ["model-value"]),
                                                            _createElementVNode("p", _hoisted_14, [
                                                                _createTextVNode("Showing "),
                                                                _createElementVNode("strong", null, _toDisplayString(sparts.results.length), 1),
                                                                _createTextVNode(" of "),
                                                                _createElementVNode("strong", null, _toDisplayString(sparts.totalFound), 1),
                                                                _createTextVNode(" results")
                                                            ])
                                                        ]),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }),
                                (screenSize.value === ScreenSize.Small)
                                    ? (_openBlock(), _createBlock(_component_v_bottom_navigation, {
                                        key: 0,
                                        "bg-color": "duskBlue"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                                onClick: _cache[8] || (_cache[8] = ($event) => (mobileFilterVisible.value = true))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, null, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("mdi-filter-cog")
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _hoisted_15
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_btn, {
                                                onClick: _cache[9] || (_cache[9] = ($event) => (mobilePartsListVisible.value = true))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, null, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("mdi-numeric-" + _toDisplayString(quote.sparts.length <= 1 ? `${quote.sparts.length}-box-outline` : ((quote.sparts.length > 9 ? 9 : quote.sparts.length) + '-box-multiple-outline')), 1)
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _hoisted_16
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_btn, {
                                                onClick: _cache[10] || (_cache[10] = ($event) => (quote.openDialog = true))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, null, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode("mdi-send-variant-outline")
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _hoisted_17
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }))
                                    : (_openBlock(), _createBlock(_component_v_col, {
                                        key: 1,
                                        cols: "12",
                                        md: "4"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_btn, {
                                                                onClick: _cache[11] || (_cache[11] = ($event) => (quote.openDialog = true)),
                                                                size: "large",
                                                                color: "duskBlue",
                                                                variant: "flat",
                                                                "prepend-icon": "mdi-invoice-text-send-outline",
                                                                block: "",
                                                                ripple: ""
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode("Request a quote")
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_divider)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(ShortPartsList, {
                                                                sparts: quote.sparts,
                                                                onToggleSparePart: toggleSparePartQuote,
                                                                "no-parts-text": _ctx.config.block_args.no_parts_hint
                                                            }, null, 8, ["sparts", "no-parts-text"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }))
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(VBottomSheet), {
                            modelValue: mobilePartsListVisible.value,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((mobilePartsListVisible).value = $event))
                        }, {
                            default: _withCtx(() => [
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                    variant: "flat",
                                    rounded: 0,
                                    onClick: _cache[12] || (_cache[12] = ($event) => (mobilePartsListVisible.value = false))
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                            default: _withCtx(() => [
                                                _createTextVNode("mdi-close")
                                            ]),
                                            _: 1
                                        }),
                                        _hoisted_18
                                    ]),
                                    _: 1
                                })), [
                                    [_directive_ripple, false]
                                ]),
                                _createVNode(_component_v_container, { class: "shortPartsList" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_col, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(ShortPartsList, {
                                                            sparts: quote.sparts,
                                                            "no-parts-text": _ctx.config.block_args.no_parts_hint,
                                                            onToggleSparePart: toggleSparePartQuote
                                                        }, null, 8, ["sparts", "no-parts-text"])
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_btn, {
                                    variant: "flat",
                                    color: "primary",
                                    rounded: 0,
                                    onClick: _cache[13] || (_cache[13] = ($event) => (quote.openDialog = true))
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                            default: _withCtx(() => [
                                                _createTextVNode("mdi-send-variant-outline")
                                            ]),
                                            _: 1
                                        }),
                                        _hoisted_19
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["modelValue"])
                    ]),
                    _: 1
                }),
                _createVNode(RequestForm, {
                    "is-open": quote.openDialog,
                    "onUpdate:isOpen": _cache[15] || (_cache[15] = ($event) => ((quote.openDialog) = $event)),
                    sparts: quote.sparts,
                    config: _ctx.config,
                    onToggleSpart: toggleSparePartQuote,
                    onRefresh: refresh
                }, null, 8, ["is-open", "sparts", "config"])
            ], 64));
        };
    }
});
